/** Sidebar gradient — overridden per theme via CSS custom property. */
export const SIDEBAR_GRADIENT = "var(--sidebar-gradient)";

export const BLUE_PRIMARY = "var(--primary)";
export const BLUE_SECONDARY = "var(--sidebar-primary)";
